import React, { useMemo } from 'react';
import { Routes, Route, Navigate, NavLink } from 'react-router-dom';
import StoreSettings from './StoreSettings.jsx';
import AdminAccountSettings from './AdminAccountSettings.jsx';
import HomepageSettings from './HomepageSettings.jsx';
import './AdminSettings.css';
import { useAuth } from '../../contexts/AuthContext';
import { normalizeUserRole, USER_ROLES } from '../../utils/adminRoles';

const tabs = [
    { to: '/admin/settings/store', label: 'Store Settings', roles: [USER_ROLES.MASTER_ADMIN, USER_ROLES.ADMIN] },
    { to: '/admin/settings/homepage', label: 'Homepage Settings', roles: [USER_ROLES.MASTER_ADMIN, USER_ROLES.ADMIN] },
    { to: '/admin/settings/account', label: 'Admin Account Settings', roles: [USER_ROLES.MASTER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.STAFF] },
];

function AdminSettings() {
    const { userRole } = useAuth();
    const normalizedRole = normalizeUserRole(userRole);
    const availableTabs = useMemo(
        () => tabs.filter((tab) => tab.roles.includes(normalizedRole)),
        [normalizedRole]
    );
    const defaultTabPath = availableTabs[0]?.to || '/admin/settings/account';

    return (
        <div className="admin-settings-wrapper">
            <div className="admin-reports-tabs">
                {availableTabs.map((tab) => (
                    <NavLink
                        key={tab.to}
                        to={tab.to}
                        className={({ isActive }) =>
                            `admin-reports-tab${isActive ? ' is-active' : ''}`
                        }
                    >
                        {tab.label}
                    </NavLink>
                ))}
            </div>
            <div className="admin-settings-content">
                <Routes>
                    <Route index element={<Navigate to={defaultTabPath} replace />} />
                    <Route
                        path="store"
                        element={normalizedRole === USER_ROLES.STAFF ? <Navigate to={defaultTabPath} replace /> : <StoreSettings />}
                    />
                    <Route
                        path="homepage"
                        element={normalizedRole === USER_ROLES.STAFF ? <Navigate to={defaultTabPath} replace /> : <HomepageSettings />}
                    />
                    <Route path="account" element={<AdminAccountSettings />} />
                    <Route path="*" element={<Navigate to={defaultTabPath} replace />} />
                </Routes>
            </div>
        </div>
    );
}

export default AdminSettings;